import getConfig from 'next/config';
import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import { TrackingContext, TRACKING_ID } from '@cvent/universal-login-web-middleware';

import { DAY_IN_SECONDS } from '@constants/duration';

const LOG = LoggerFactory.create('RequestHelper');
const { publicRuntimeConfig } = getConfig();

/**
 * Retrieve client-side cookie by name.
 *
 * @param name - key to use when searching within cookies
 * @returns value tied to requested cookie
 */
export const getCookie = (name: string, providedCookies?: string): string | undefined => {
  const cookie = {};
  let cookies: string;

  if (providedCookies) {
    cookies = providedCookies;
  } else if (typeof window !== 'undefined') {
    cookies = document.cookie;
  } else {
    return;
  }

  cookies.split(';').forEach(el => {
    const [k, v] = el.split('=');
    cookie[k.trim()] = v;
  });

  return cookie[name];
};

export const setCookie = (
  name: string,
  value: string,
  durationInSeconds = DAY_IN_SECONDS,
  domain = publicRuntimeConfig.DOMAIN
): void => {
  if (typeof window === 'undefined') return;

  document.cookie = `${name}=${value}; max-age=${durationInSeconds}; samesite=lax; domain=${domain}; path=/`;
};

export const buildTrackingContext = (headers): TrackingContext => {
  let localHeaders = headers;
  if (!(headers instanceof Headers)) {
    localHeaders = new Headers(headers);
  }
  const requestId = getCookie(TRACKING_ID, localHeaders.get('cookie'));

  if (!requestId) {
    LOG.error({ msg: 'Request encountered without required request id.', headers });
  }

  return {
    LoginRequestId: requestId ?? 'NOT_FOUND'
  };
};
